import { Component, Input, OnInit } from '@angular/core';
import { WidgetType } from 'src/app/customer-modules/apolus/dashboard/dashboard.component';
import { AppService, LabelValue } from 'common-cloudstudio';

@Component({
  selector: 'app-widget',
  templateUrl: './widget.component.html',
  styleUrls: ['./widget.component.scss']
})
export class WidgetComponent implements OnInit {
  @Input() widget: any;
  
  WidgetType = WidgetType;

  constructor(public appService: AppService) {}

  ngOnInit(): void {
  }

  isValidWidgetType(type: number): boolean {
    return Object.values(WidgetType).includes(type);
  }

  getCurrentTimestamp(): string {
    return new Date().toLocaleString('es-ES', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  getWidgetCardClasses(): string[] {
    const classes = [];
    
    if (this.widget?.WidgetID) {
      classes.push(`widget-${this.widget.WidgetID}`);
    }
    
    return classes;
  }

  getWidgetTitle(): string {
    switch (this.widget?.WidgetID) {
      case WidgetType.ConectivityTable:
        return 'Tabla de Estado';
      case WidgetType.DeviceSummary:
        return this.widget.StatusSummaryData?.Title || 'Resumen de Estado';
      default:
        return `Widget ${this.widget?.WidgetID}`;
    }
  }

  getStatusSummaryData(): any {
    if (this.widget?.WidgetID === 122132) {
      return this.widget.StatusSummaryData;
    }
    return null;
  }

  getXyChartData(): any {
    if (this.widget?.WidgetID === 122132) {
      return this.widget.XYChartData;
    }
    return null;
  }

  shouldShowHeader(): boolean {
    return true;
  }

  shouldShowActions(): boolean {
    return true;
  }

  getWidgetType(): number {
    return this.widget?.WidgetID;
  }

  getWidgetDescriptor(): any {
    return {
      id: this.widget?.WidgetID,
      type: this.widget?.WidgetID,
      title: this.getWidgetTitle()
    };
  }
}
